export const bewindvoerdersCuratorenEn = {
  BewindvoerdersCuratorenClientAanmeldenFormulierStapInleiding: "Introduction",
  BewindvoerdersCuratorenClientAanmeldenFormulierMijnClient: "My client",
  BewindvoerdersCuratorenClientWijzigenFormulierStapInleiding: "Introduction",
  BewindvoerdersCuratorenClientWijzigenFormulierMijnVraag: "My question",
  BewindvoerdersCuratorenClientContactFormulierStapInleiding: "Introduction",
  BewindvoerdersCuratorenClientContactFormulierMijnClient: "My client",
  UBentWsnp: "WSNP trustee or curator in bankruptcy",
  UBentFamilielidOnbekend: "Trustee or curator for a family member or acquaintance",
  UBentProfessional: "Professional trustee or curator"
};
